<template>
  <section>
    <div
      v-if="pcyStts != 420"
      class="main flex-sb">
      <div class="tips">
        <font-awesome-icon
          icon="flag-checkered"
          class="flag"/>
        This policy is ready to be sent to the insurer for issuing.
      </div>
      <div class="btn">
        <v-button
          v-if="status == 0"
          icon="user-lock"
          @click="submit">Bot Issue Cover Note</v-button>
        <v-button
          v-if="status == 1"
          icon="user-lock"
          disabled>Waiting for Cover Note PDF...</v-button>
      </div>
    </div>
    <div
      v-if="status == 2"
      class="success">
      <div class="tips">
        <font-awesome-icon
          icon="check"
          class="check"/>
        Bot Issue Cover Note Successful. No.: {{coverNoteId}}
      </div>
    </div>
    <div
      v-else-if="status == -1"
      class="fail">
      <div class="tips">
        <font-awesome-icon
          icon="triangle-exclamation"
          class="check"/>
        Bot Issue Cover Note Failed. Please issue manually.
      </div>
    </div>

    <!-- dialog -->
    <v-dialog
      v-model="dialog"
      width="370px">
      <div class="dialog-container">
        <h4>Bot Issue Cover Note</h4>
        <div class="dialog-main">
          <div
            v-if="status == 2"
            class="content">Cover note requested, No.: {{coverNoteId}}
            The PDF file will be added when recieved.</div>
          <div
            v-else-if="status == -1"
            class="content">Cover note request failed. Please issue manually.</div>
          <v-button
            class="btn"
            @click="dialog = false">OK</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import {submitCoverNote, loadCoverNote} from '@/api/policy'
export default {
  name: 'CoverNote',
  props:{
    orderId:{
      type: [String, Number],
      default: 0
    },
    coverNoteStatus:{
      type: [String, Number],
      default: 0
    },
    coverNoteNum:{
      type: [String, Number],
      default: 0
    },
    pcyStts:{
      type: [String, Number],
      default: 0
    }
  },
  data () {
    return {
      coverNoteId: 0,
      dialog: false,
      timer: null,
      status: 0
    }
  },
  watch:{
    coverNoteStatus:{
      immediate: true,
      handler(val){
        this.status = val
        if(val == 1){
          this.loadingStatus()
        }
      }
    },

    coverNoteNum:{
      immediate: true,
      handler(val){
        this.coverNoteId = val
      }
    }
  },
  methods: {
    submit(){
      this.network().submitCoverNote()
    },

    loadingStatus(){
      // 轮询
      this.timer = setInterval(() => {
        this.network().loadCoverNote()
      }, 3000)
    },

    network(){
      return {
        submitCoverNote: async ()=> {
          const {status} = await submitCoverNote({
            order_id:this.orderId
          })
          if(status == 200){
            this.$emit('loading', true)
            this.loadingStatus()
          }
        },

        loadCoverNote: async ()=> {
          const {data} = await loadCoverNote({
            order_id:this.orderId
          })
          if(data.covernote_status != 1){
            this.$emit('loading', false)
            clearInterval(this.timer)
            this.status = data.covernote_status
            this.coverNoteId = data.cvr_nt_no
            this.dialog = true
          }
          if(data.covernote_status == 2){
            // 成功之后刷新数据
            this.$emit('refreshData')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
section{
  margin-bottom: 20px;
  .main{
    background: #FFFBDD;
    height: 64px;
    border: 1px solid rgba(176, 136, 0, 0.2);
    box-sizing: border-box;
    border-radius: 6px;
    margin-bottom: 20px;
    .tips{
      margin: 22px 0 22px 15px; 
      .flag{
        color: rgba(176, 136, 0, 1);
        margin-right: 15px;
      }
    }
    .btn{
      margin: 16px 15px 16px 0; 
    }
  }
  .success{
    background: #DCFFE4;
    border: 1px solid rgba(23, 111, 44, 0.2);
    box-sizing: border-box;
    border-radius: 6px;
    height: 64px;
    .tips{
      margin: 22px 0 22px 15px; 
      .check{
        color: rgba(34, 134, 58, 1);
        margin-right: 15px;
      }
    }
  }
  .fail{
    background: #FFE3E6;
    border: 1px solid rgba(158, 28, 35, 0.2);
    box-sizing: border-box;
    border-radius: 6px;
    height: 64px;
    .tips{
      margin: 22px 0 22px 15px; 
      .check{
        color: rgba(203, 36, 49, 1);
        margin-right: 15px;
      }
    }
  }
  .dialog-container{
    border-radius: 6px;
    h4{
      background: #F6F8FA;
      border: 1px solid #E1E4E8;
      box-sizing: border-box;
      padding: 16px;
      font-weight: 600;
    }
    .dialog-main{
      margin: 0 15px;
      .content{
        margin: 20px 0;
      }
      .btn{
        margin-bottom: 15px;
        width: 100%;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
}
</style>
